exelare_jobs.define('appFormModel',['noconflict','knockout', 'underscore'], function ($, ko, _) {
    return function () {
        var self = this;
        var formControls = $('#appForm [data-fieldname]');
        var fileControls = $('#appForm [type="file"]');
        var validatorFields = {};

        self.applyJobTitle = ko.observable("Submit Resume");
        self.applyJobReqID = ko.observable("");

        self.getFieldValue = function (formControl) {
            var fieldName = $(formControl).attr("data-fieldname");
            var fieldNameSubs = $(formControl).attr("data-fieldname-subs");
            var isArray = $(formControl).attr("data-array");
            var dataType = $(formControl).attr("data-type");
            
            if (typeof fieldNameSubs == "undefined") {
                if (dataType == "date") {
                    var seldate=$(formControl).datepicker('getDate');
                    if (seldate=='Invalid Date') return "";

                    return seldate.yyyymmdd();
                }
                
                return self[fieldName]();
            } else {
                var subs = fieldNameSubs.split(",");
                var results = [];
                for (var i = 0; i < subs.length; i++) {
                	var subVal = $.trim(self[fieldName + "_" + subs[i]]());
                	if (subVal.length > 0) {
                		results.push(subVal);
                	}
                }
                return results;
            }
        }
        
        self.getValidatorObject = function (formControl) {
            var validator = {};
            var requiredVal = $(formControl).attr('required');
            var choiceRequiredVal = $(formControl).attr('choice-required');
            var patternVal = $(formControl).attr('pattern');
            var fileSize = $(formControl).attr('data-filesize');
                        
            if (typeof requiredVal !== typeof undefined && requiredVal !== false) {
                validator.nonEmpty = {message: 'This field is required.'}
            }

            if (typeof choiceRequiredVal !== typeof undefined && choiceRequiredVal !== false) {
            	validator.choice = {min:1, message: 'Please, select at least one choice.'}
            }

            if (patternVal) {
                validator.regexp = {
                    regexp: new RegExp(patternVal),
                    message: 'Pls enter in the following format ex ' + $(formControl).attr('placeholder')
                }
            }

            if (fileSize) {
                validator.file =  {
                        maxSize: fileSize*1024*1024,   // 2048 * 1024
                        message: 'File size greater than ' + fileSize + ' MBs is not permitted'
                    }
            }

            return validator;
        }

        self.setFieldValue = function (formControl) {
        	var fieldId = $(formControl).attr("id");
        	var validatingControlName = $(formControl).attr("data-validating-control");
            var fieldName = $(formControl).attr("data-fieldname");
            var fieldNameSubs = $(formControl).attr("data-fieldname-subs");
            var isArray = $(formControl).attr("data-array");
            var lookup = $(formControl).attr("data-lookup");
            var dataType = $(formControl).attr("data-type");

            if (!validatingControlName) validatingControlName = fieldId;

            $(formControl).attr('name', fieldId);

            validatorFields[validatingControlName] = { validators: self.getValidatorObject(formControl) };

            if (typeof dataType == "undefined") dataType = "string";
            if (typeof fieldNameSubs == "undefined") {
                self[fieldName] = self.getFieldType(dataType, isArray);
            } else {
                var subs = fieldNameSubs.split(",");
                for (var i = 0; i < subs.length; i++) {
                    self[fieldName + "_" + subs[i]] = self.getFieldType(dataType, isArray);
                }
            }

            if (lookup) {
                var fieldNameLookup = fieldName + "Lookup";
                self[fieldNameLookup] = ko.observableArray([]);
                setTimeout(helpers.getService, 1000, 'lookup', {
                    companyId: ExelareSettings.curCompanyId,
                    userId: ExelareSettings.curUserId,
                    pwd: ExelareSettings.curPwd ? ExelareSettings.curPwd : '',
                    lookupPath: lookup,
                    lookupName: fieldNameLookup
                }, function (resp) {
                    self[fieldNameLookup](resp.Records);
                });
            }
        }

        self.getFieldType=function(dataType, isArray) {
            if (typeof isArray == "undefined" || isArray == false) {
                if (dataType == "bool") return ko.observable(false);
                if (dataType == "currency") return ko.observable(0).money();

                return ko.observable("");
            } else {
                return ko.observableArray([]);
            }
        }
		
        self.isReady = ko.observable(true);

        self.submitResume = function () {
            if (typeof(isFormValid)!="undefined" && isFormValid===false) return


        	$('#appForm').data('bootstrapValidator').validate();
        	
        	if (!$('#appForm').data('bootstrapValidator').isValid()) {
        		if ($('#appForm .has-error .form-control').length > 0) {
        			$('#appForm .has-error .form-control')[0].focus();
        		} else if ($('#appForm .has-error input[type="radio"]').length > 0) {
        			$('#appForm .has-error input[type="radio"]')[0].focus();
        		} else if ($('#appForm .has-error input[type="checkbox"]').length > 0) {
        			$('#appForm .has-error input[type="checkbox"]')[0].focus();
        		};
				        		
        		return false;
        	} 

			if (typeof FormData == "undefined") {
                alert("Your browser is too old. Please, upgrade it to later version, or use Chrome/Firefox/Safari.");
                return false;
			}

			self.isReady(false);
			$('#btnResumeSubmit').button('loading');
			
			passedArgs={}
			if (window.location.hash) {
				passedArgs = $.deparam.fragment();
            }

            if (window.location.search) {
                passedArgs = $.deparam.querystring();
            }

            console.log(passedArgs);

			if (!passedArgs['source'] && /\S/.test(passedArgs['source'])) passedArgs['source']='Web'

			setTimeout(function () {
				var formData = new FormData();

				for (var i = 0; i < formControls.length; i++) {
					var fieldName = $(formControls[i]).attr("data-fieldname");

					formData.append("CandidateInfo." + fieldName, self.getFieldValue(formControls[i]));
				}
				formData.append("CandidateInfo.uuSourceWebSites", passedArgs['source']);
				formData.append("AccountInfo.SubmitType", $("#appForm").attr("data-submitType"));
				formData.append("AccountInfo.CompanyID", ExelareSettings.curCompanyId);
				formData.append("AccountInfo.UserID", ExelareSettings.curUserId);
				formData.append("AccountInfo.ApplyUsingEmail", $("#appForm").attr("data-applyUsingEmail")?$("#appForm").attr("data-applyUsingEmail"):"");

				formData.append("JobInfo.ReqID", self.applyJobReqID());

				if ($("#ctrlResume").length > 0) formData.append("ResumeFile", $("#ctrlResume")[0].files[0]);

				$(".document").each(function() {
					formData.append($(this).attr("id"), $(this)[0].files[0]);
					formData.append($(this).attr("id") + ".Subject", $(this).attr("data-docsubject"));
					formData.append($(this).attr("id") + ".DocType", $(this).attr("data-doctype"));
					formData.append($(this).attr("id") + ".DocSubType", $(this).attr("data-docsubtype"));
				});
				
				$.ajax({
					url: ExelareSettings.serviceUrl + "form",
					type: 'POST',
					data: formData,
					async: false,
					cache: false,
					contentType: false,
					processData: false
				}).done(function (data) {
					self.isReady(true);
					$('#btnResumeSubmit').button('reset');
					$('#appFormModal').modal('hide');

					if (ExelareSettings.thankYouPageUrl) {
					    window.location = ExelareSettings.thankYouPageUrl;
					} else {
                        alert("Application is successfully submitted");
                        if (ExelareSettings.trackerUrl) {
                            var trackerImg = $("<img/>").attr("src", ExelareSettings.trackerUrl).attr("id", "cbiz_tracker_img");
                            $('body').append(trackerImg);
                            setTimeout(function() {
                                $('#cbiz_tracker_img').remove();
                            }, 5000);
                        }
					}
					

				}).fail(function (data) {
					self.isReady(true);
					$('#btnResumeSubmit').button('reset');
					$('#appFormModal').modal('hide');
					alert(data.responseJSON.Message);
					console.log(data);
				});
			}, 1);
			
			return false;
        };

        self.initializeValidator = function () {
            $('#appForm').bootstrapValidator({
                feedbackIcons: {
                    valid: 'glyphicon glyphicon-ok',
                    invalid: 'glyphicon glyphicon-remove',
                    validating: 'glyphicon glyphicon-refresh'
                },
                fields: validatorFields,
                live: 'enabled',
                //submitButtons: '#btnResumeSubmit',
               // excluded: [':disabled', ':hidden', ':not(:visible)', '.novalidate'],
                //submitHandler: null
            })
        }

        //initializing members
        for (var i = 0; i < formControls.length; i++) {
            self.setFieldValue(formControls[i]);
        }

        //initializing file members
        for (var i=0;i<fileControls.length;i++) {
            var fileControl=$(fileControls[i]);
            validatorFields[fileControl.attr("id")] = { validators: self.getValidatorObject(fileControl) };
        }

        //  console.log(validatorFields);
        //	initialize validators
	    //  if ($('#appFormModal').length == 0) {
        //		self.initializeValidator();
		//	}
    };
});


